import { FootchinkoItem } from "./FootchinkoItem";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { AudioManager } from "../../AudioManager";

    export class Plank extends FootchinkoItem {

        constructor(game: Phaser.Game, x: number, y: number, rotation: number, hits: number) {

            super ( game, x, y, "texture_atlas_1", true, false, rotation , null, hits);

            this.canBeHit = true;
        }

        public setBody(): void {

            // definir el cuerpo
            this.body.setRectangle(68, 28 , 0, 2 );
            this.body.rotation = this.itemRotation;
            this.body.mass = 10e8;
            this.body.static = true;
            this.body.setMaterial( GameVars.getInstance().materials.plankMaterial);
        }

        public setView(): void {

            super.setView();

            // la vista
            this.burntFrameName = "burnt-plank";

            switch ( this.hits ) {

                case 4:
                    this.name = GameConstants.BREAKABLE_PLANK_4;
                    this.frameName = "breakable-plank-4";
                    break;
                case 3:
                    this.name = GameConstants.BREAKABLE_PLANK_3;
                    this.frameName = "breakable-plank-3";
                    break;
                case 2:
                    this.name = GameConstants.BREAKABLE_PLANK_2;
                    this.frameName = "breakable-plank-2";
                    break;
                case 1:
                    this.name = GameConstants.BREAKABLE_PLANK_1;
                    this.frameName = "breakable-plank-1";
                    break;
                default:
            }

            this.animations.add("disappear", Phaser.Animation.generateFrameNames("peg_disappear_", 1, 4 , "", 4));
        }

        public hit(): void {

            super.hit();

            if (this.hits === 0) {

                this.animations.play("disappear", 30)
                    .onComplete.add(this.kill, this);
                    
            } else {

                switch ( this.hits ) {
                    case 3:
                        this.frameName = "breakable-plank-3";
                        break;
                    case 2:
                        this.frameName = "breakable-plank-2";
                        break;
                    case 1:
                        this.frameName = "breakable-plank-1";
                        break;
                    default:
                }

                this.scale.setTo( 1, .75);
                this.game.time.events.add(100, function(): void {
                    this.scale.set(1);
                }, this);
            }

            AudioManager.getInstance().playEffect("madera_rajada");
        }
    }
